import { useEffect } from "react";
import type { ReactNode } from "react";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
  footer?: ReactNode;
  wide?: boolean;
}

export function Modal({ open, onClose, title, children, footer, wide }: ModalProps) {
  useEffect(() => {
    if (!open) return;
    function onKey(e: KeyboardEvent) {
      if (e.key === "Escape") onClose();
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-40 flex items-center justify-center bg-black/70 p-4"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className={"w-full rounded " + (wide ? "max-w-3xl" : "max-w-lg") + " border border-zinc-700 bg-zinc-900 shadow-xl"}>
        <div className="flex items-center justify-between border-b border-zinc-800 px-4 py-3">
          <h3 className="text-base font-medium">{title}</h3>
          <button
            onClick={onClose}
            className="text-zinc-400 hover:text-zinc-100"
            aria-label="Close"
          >
            ✕
          </button>
        </div>
        <div className="p-4 text-sm">{children}</div>
        {footer && (
          <div className="flex justify-end gap-2 border-t border-zinc-800 px-4 py-3">{footer}</div>
        )}
      </div>
    </div>
  );
}
